import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppBar, Box, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton, Slide, Toolbar, } from '@mui/material';
import { Icons } from '~/views/atoms/icons';
import { Button } from '~/views/atoms/button';
import { forwardRef, useCallback, useMemo } from 'react';
import { UIService } from '~/services/service.ui';
import { t } from 'i18next';
import { useService } from '~/services/service.base';
import { FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { useFormikModel } from '~/tools/formik.model';
import { FilterModel } from '~/models/filter.model';
import { MediaSearchService } from '~/services/service.media.search';
import { useStyles } from '~/views/organisms/filter/styles';
import { FormMediaFilter } from '~/views/molecules/form-media-filter/form.media.filter';
import { ServicePaginator } from '~/services/service.paginator';
import { theme } from '~/theme/default';
import { ECheckboxState } from '~/shared/types';
const Transition = forwardRef(function Transition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
const sxToolbar = { height: UIService.TOOLBAR_SEARCH_HEIGHT, justifyContent: 'space-between', gap: 1 };
export const Filter = () => {
    const mediasService = useService(MediaSearchService);
    const { openFilterSvc } = mediasService;
    const navigate = useNavigate();
    const classes = useStyles();
    const servicePaginator = useService(ServicePaginator);
    const onSubmit = useCallback((values) => {
        const tags = Object.keys(values).filter(key => values[key] && values[key]?.toString() === ECheckboxState.on);
        servicePaginator.resetPaginatorData();
        mediasService.setTags(tags);
        mediasService.setOriginalFilters(values);
        openFilterSvc.handleClose();
        navigate(ROUTES.FUNDS.MEDIA.SEARCH_RESULT.path);
    }, [mediasService, navigate, openFilterSvc, servicePaginator]);
    const initialValues = useMemo(() => {
        return mediasService.originalFilters[mediasService.categoryId] || {};
    }, [mediasService.originalFilters, mediasService.categoryId]);
    const formik = useFormikModel(FilterModel, {
        initialValues,
        onSubmit,
        validateOnMount: true,
        validateOnChange: true,
    });
    return (_jsx(FormikProvider, { value: formik, children: _jsxs(Dialog, { className: classes.dialogContainer, fullScreen: true, open: openFilterSvc.open, TransitionComponent: Transition, children: [_jsxs(AppBar, { sx: { backgroundColor: theme.palette.background.default }, color: "inherit", position: "relative", children: [_jsxs(Toolbar, { sx: sxToolbar, children: [_jsx(Box, { className: classes.title, children: t('MEDIAS_FILTRES') }), _jsx(IconButton, { color: "inherit", edge: "end", onClick: openFilterSvc.handleClose, children: _jsx(Icons.Close, { color: "primary" }) })] }), _jsx(Divider, {})] }), _jsx(DialogContent, { sx: { backgroundColor: theme.palette.background.default, maxHeight: "380px" }, children: _jsx(FormMediaFilter, {}) }), _jsx(DialogActions, { sx: { backgroundColor: theme.palette.background.default }, children: _jsxs(Grid, { container: true, flexDirection: "column", children: [_jsx(Grid, { item: true, className: classes.button, children: _jsx(Button, { fullWidth: true, onClick: formik.submitForm, children: t('MEDIAS_FILTERS_ENREGISTRER') }) }), _jsx(Grid, { item: true, className: classes.button, children: _jsx(Button, { className: classes.clearButton, fullWidth: true, onClick: () => formik.resetForm({ values: {} }), children: t('MEDIAS_FILTERS_CLEAR_ALL') }) })] }) })] }) }));
};
